module.exports = __webpack_public_path__ + "img/matbg.6eaf2421.png";